module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "milestones donate-carousel",
    attrs: {
      "id": "impact-project-milestones"
    }
  }, [_c('VueSlickCarousel', _vm._b({
    staticClass: "milestones-wrapper"
  }, 'VueSlickCarousel', _vm.settings, false), _vm._l((_vm.milestones), function(mile) {
    return _c('div', {
      key: mile.index,
      staticClass: "mile",
      class: {
        active: mile.index == _vm.currentMile, 'mile-lg': _vm.milestones.length > 4
      }
    }, [_c('div', {
      staticClass: "mile-inner-box"
    }, [_c('div', {
      staticClass: "location-wrapper"
    }, [_c('i', {
      staticClass: "fas fa-map-marker-alt"
    })]), _vm._v(" "), _c('p', {
      staticClass: "mile-index wwf-font"
    }, [_vm._v(_vm._s(mile.index))]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(mile.description))]), _vm._v(" "), _c('p', {
      staticClass: "mile-step wwf-font"
    }, [_vm._v(_vm._s(_vm.currentStepText(mile)))])])])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d8144e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=a9gwdhtvlz!./~/string-replace-webpack-plugin/loader.js?id=zp0damlfgbk!./src/components/impact-project/ImpactProjectMilestones.vue
// module id = 667
// module chunks = 0